import type { SanityHeroForm } from '#/lib/sanity/queries/heroForm';
import { cn, COLORS } from '#/lib/utils';

import { FormCustom } from './Form/Custom';
import { Headline } from './Headline';
import { LogoMarquee } from './LogoMarquee';
import { Media } from './Media';
import { RichText } from './RichText';
import { SocialProof } from './SocialProof/SocialProof';

export function HeroForm(props: SanityHeroForm) {
  const isFirst = props.sectionIndex === 0;

  return (
    <div
      className={cn('p-main bg-cloud', {
        'rounded-35 py-100': !isFirst,
        'mt-[calc(var(--header-height)*-1)] pt-[calc(var(--header-height)+3rem)]':
          isFirst,
      })}
    >
      <div className="grid-main mx-auto max-w-full l:max-w-1500">
        <div className="col-span-full l:col-span-6">
          <div className="max-w-600 l:max-w-490 l:mx-auto h-full flex flex-col">
            <Headline
              value={props.headline}
              className="mb-25 text-32 m:text-43 l:text-43"
            />
            <RichText
              value={props.bodyCopy ?? []}
              normalTextSizeClassName="text-body"
            />
            <SocialProof socialProof={props.socialProof} />
            <div className="flex-1 mt-20">
              <FormCustom
                className="h-full flex flex-col"
                form={props.form}
                confirmation={{
                  ...props.formConfirmation,
                  headline: undefined,
                }}
              />
            </div>
          </div>
        </div>
        <div className="hidden l:block col-span-6 l:col-start-7">
          <Media loopVideo={false} media={props.formMedia} sizes="50vw" />
        </div>
      </div>
      {props.logoMarquee && (
        <LogoMarquee
          {...props.logoMarquee}
          background={COLORS.cloud}
          foreground={COLORS.charcoal}
          className="mt-20"
        />
      )}
    </div>
  );
}
